module.exports = __webpack_public_path__ + "static/media/open-education-stepper.3e4b6cf4.png";